import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiChevronLeft, FiChevronRight } = FiIcons;

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('all');

  const galleryImages = [
    {
      id: 1,
      src: 'https://i.ibb.co/qLGgY7dH/Nashmi-barber-shop-Cutting-1.jpg',
      alt: 'Professional Haircut',
      category: 'haircuts'
    },
    {
      id: 2,
      src: 'https://i.ibb.co/B24tDf5q/Nashmi-barber-shop-Cutting-1.jpg',
      alt: 'Precision Cutting',
      category: 'haircuts'
    },
    {
      id: 3,
      src: 'https://i.ibb.co/C3x4vDY8/Nashmi-barber-shop-Cutting-2.jpg',
      alt: 'Beard Styling',
      category: 'beard'
    },
    {
      id: 4,
      src: 'https://i.ibb.co/p6G0qNWy/Nashmi-barber-shop-Cutting-3.jpg',
      alt: 'Professional Service',
      category: 'haircuts'
    },
    {
      id: 5,
      src: 'https://i.ibb.co/cKht7Gmv/Nashmi-barber-shop-Cutting-4.jpg',
      alt: 'Hair Washing',
      category: 'services'
    },
    {
      id: 6,
      src: 'https://i.ibb.co/d0LBbVMv/Nashmi-barber-shop-Hair-Style-1.jpg',
      alt: 'Modern Hairstyle',
      category: 'styles'
    },
    {
      id: 7,
      src: 'https://i.ibb.co/r2r5tKn5/Nashmi-barber-shop-Hair-Style-1.jpg',
      alt: 'Stylish Cut',
      category: 'styles'
    },
    {
      id: 8,
      src: 'https://i.ibb.co/ZpTcSrwJ/Nashmi-barber-shop-Hair-Style-2.jpg',
      alt: 'Contemporary Style',
      category: 'styles'
    },
    {
      id: 9,
      src: 'https://i.ibb.co/4RrcPL5H/Nashmi-barber-shop-inside-image-1.jpg',
      alt: 'Shop Interior',
      category: 'interior'
    },
    {
      id: 10,
      src: 'https://i.ibb.co/HLj4vV96/Nashmi-barber-shop-inside-image-2.jpg',
      alt: 'Barber Station',
      category: 'interior'
    },
    {
      id: 11,
      src: 'https://i.ibb.co/v6hm87mj/Nashmi-barber-shop-inside-image-3.jpg',
      alt: 'Professional Setup',
      category: 'interior'
    },
    {
      id: 12,
      src: 'https://i.ibb.co/xq3s6C97/Nashmi-barber-shop-Inside.jpg',
      alt: 'Shop Ambiance',
      category: 'interior'
    },
    {
      id: 13,
      src: 'https://i.ibb.co/rK6WnvMt/Nashmi-barber-shop-Outside-2.jpg',
      alt: 'Shop Exterior',
      category: 'exterior'
    },
    {
      id: 14,
      src: 'https://i.ibb.co/JFcSy86d/Nashmi-barber-shop-Outside-Image.jpg',
      alt: 'Shop Front',
      category: 'exterior'
    }
  ];

  const categories = [
    { id: 'all', name: 'All' },
    { id: 'haircuts', name: 'Haircuts' },
    { id: 'beard', name: 'Beard Styling' },
    { id: 'styles', name: 'Hair Styles' },
    { id: 'interior', name: 'Interior' },
    { id: 'exterior', name: 'Exterior' }
  ];

  const filteredImages = selectedCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const navigateImage = (direction) => {
    if (!selectedImage) return;
    
    const currentIndex = filteredImages.findIndex(img => img.id === selectedImage.id);
    let newIndex;
    
    if (direction === 'next') {
      newIndex = (currentIndex + 1) % filteredImages.length;
    } else {
      newIndex = currentIndex === 0 ? filteredImages.length - 1 : currentIndex - 1;
    }
    
    setSelectedImage(filteredImages[newIndex]);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="pt-20"
    >
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-r from-luxury-charcoal to-luxury-darkCharcoal text-white">
        <div className="container mx-auto px-4">
          <motion.div
            className="text-center"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl font-bold mb-6">
              Our <span className="text-luxury-gold">Gallery</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Explore our work and see the transformation we create for our valued clients
            </p>
          </motion.div>
        </div>
      </section>

      {/* Filter Buttons */}
      <section className="py-8 bg-gray-50 dark:bg-luxury-charcoal">
        <div className="container mx-auto px-4">
          <motion.div
            className="flex flex-wrap justify-center gap-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-2 rounded-full font-semibold transition-all duration-300 ${
                  selectedCategory === category.id
                    ? 'bg-luxury-gold text-black'
                    : 'bg-white dark:bg-luxury-darkCharcoal text-gray-700 dark:text-gray-300 hover:bg-luxury-gold hover:text-black'
                }`}
              >
                {category.name}
              </button>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <motion.div 
            className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
            layout
          >
            <AnimatePresence>
              {filteredImages.map((image, index) => (
                <motion.div
                  key={image.id}
                  className="relative group cursor-pointer overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.8 }}
                  transition={{ duration: 0.5, delay: index * 0.05 }}
                  layout
                  onClick={() => openModal(image)}
                  whileHover={{ y: -5 }}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-white text-center">
                      <p className="font-semibold">{image.alt}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>

      {/* Modal */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeModal}
          >
            <motion.div
              className="relative max-w-4xl max-h-full"
              initial={{ scale: 0.5 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.5 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={closeModal}
                className="absolute top-4 right-4 z-10 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 transition-colors duration-300"
              >
                <SafeIcon icon={FiX} className="w-6 h-6" />
              </button>

              <button
                onClick={() => navigateImage('prev')}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 transition-colors duration-300"
              >
                <SafeIcon icon={FiChevronLeft} className="w-6 h-6" />
              </button>

              <button
                onClick={() => navigateImage('next')}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 transition-colors duration-300"
              >
                <SafeIcon icon={FiChevronRight} className="w-6 h-6" />
              </button>

              <img
                src={selectedImage.src}
                alt={selectedImage.alt}
                className="max-w-full max-h-full object-contain rounded-lg"
              />

              <div className="absolute bottom-4 left-4 right-4 text-center">
                <p className="text-white font-semibold bg-black/50 px-4 py-2 rounded-full inline-block">
                  {selectedImage.alt}
                </p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* CTA Section */}
      <section className="py-16 bg-luxury-gold">
        <div className="container mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl font-bold text-black mb-4">Like What You See?</h2>
            <p className="text-xl text-black/80 mb-8">Book your appointment and join our satisfied clients</p>
            <a
              href="tel:+971507096230"
              className="bg-black text-luxury-gold px-8 py-4 rounded-full font-semibold hover:bg-gray-800 transition-colors duration-300 inline-block"
            >
              Book Your Appointment
            </a>
          </motion.div>
        </div>
      </section>
    </motion.div>
  );
};

export default Gallery;